<template>
  <div>
    <div class='container-fluid'>
      <div class='col-lg-12' style='padding:0px'>
        <div class="form-alerts">
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors.length > 0'>
          <ul>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        </div>
        <fieldset>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>الفرع:</label>
            <select @change='FillItineraries(true);FillMaintenanceGroups(true)' class="form-control" style="padding: 0px" v-model="record.branche_id">
              <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>الخط:</label>
            <select @change='FillRegions(true)'  class="form-control" style="padding: 0px" v-model="record.line_id">
              <option v-for="line in lines" v-bind:key="line.id" v-bind:value="line.id">
                {{ line.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>المنطقة:</label>
            <select class="form-control" style="padding: 0px" v-model="record.region_id">
              <option v-for="item in regions" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.region_name }}
              </option>
            </select>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>الاسم:</label>
            <input v-model='record.name' class='form-control' name='name' type='text'>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>اسم الشهرة:</label>
            <input v-model='record.nickname' class='form-control' name='nickname' type='text'>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <div>
              <div class='col-lg-6 col-md-6 col-sm-6' style="padding: 0px">
                  <label>رقم السجل</label>
                  <input v-model='record.rec_id' class='form-control' name='nickname' type='text'>
              </div>
              <div class='col-lg-6 col-md-6 col-sm-6' style="padding: 0px 5px 0px 0px;">
                  <label>حالة المراجعة</label>
                  <select style="padding: 0px" class="form-control" v-model="record.reviewType">
                    <option value='0'>بدون مراجعه</option>
                    <option value='1'>مراجعة أولى</option>
                    <option value='2'>مراجعة ثانية</option>
                    <option value='3'>مراجعة ثالثة</option>
                  </select>
              </div>
            </div>
          </div>
          <div class='col-lg-3 col-md-3 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>رقم البطاقة:</label>
            <input v-model='record.idcard' class='form-control' name='idcard' type='text'>
          </div>
          <div class='col-lg-3 col-md-3 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>المحافظة:</label>
            <select  @change='FillCitys(true)' class="form-control" style="padding: 0px" v-model="record.governorate">
              <option v-for="(item) in governorates" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-3 col-md-3 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>المركز/المدينه/الحى:</label>
            <select class="form-control" style="padding: 0px" v-model="record.city">
              <option v-for="(city) in cities" v-bind:key="city.id" v-bind:value="city.id">
                {{ city.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-3 col-md-3 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>القرية:</label>
            <input v-model='record.village' class='form-control' name='village' type='text'>
          </div>
          <div class='col-lg-8 col-md-8 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>العنوان:</label>
            <input v-model='record.address' class='form-control' name='address' type='text'>
          </div>
          <div class='col-lg-2 col-md-2 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>التقييم:</label>
            <select class="form-control" style="padding: 0px" v-model="record.evaluation">
              <option v-for="evalu in evalus" v-bind:key="evalu.id" v-bind:value="evalu.id">
                {{ evalu.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-2 col-md-2 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>الحالة:</label>
            <select class="form-control" style="padding: 0px" v-model="record.active">
              <option v-for="type in types" v-bind:key="type.id" v-bind:value="type.id">
                {{ type.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-3 col-md-3 col-sm-6' style='padding: 10px 0px 0px 10px;'>
              <label>محمول1</label>
              <div class="form-group input-group">
                  <span class="input-group-btn">
                    <button
                      class="btn btn-default"
                      type="button"
                      title="تواصل عبر واتساب"
                      @click="openWhatsapp(record.mobile)">
                      <i class="fa fa-send" style="color: green;"></i>
                    </button>
                  </span>
                  <input v-model='record.mobile' class='form-control' name='nickname' type='text'>
              </div>
          </div>
          <div class='col-lg-3 col-md-3 col-sm-6' style='padding: 10px 0px 0px 10px;'>
              <label>محمول2 / الأرضى</label>
              <div class="form-group input-group">
                  <span class="input-group-btn">
                    <button
                      class="btn btn-default"
                      type="button"
                      title="تواصل عبر واتساب"
                      @click="openWhatsapp(record.mobile2)">
                      <i class="fa fa-send" style="color: green;"></i>
                    </button>
                  </span>
                  <input v-model='record.mobile2' class='form-control' name='nickname' type='text'>
              </div>
          </div>
          <div class='col-lg-3 col-md-3 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>الموقع</label>
            <div class="form-group input-group">
              <span class="input-group-btn">
                  <button @click="openLocation(record.location)" class="btn btn-default" type="button"><i class="fa fa-map-marker" style="color: blue;"></i>
                  </button>
              </span>
              <input readonly  autocomplete="off"   onpaste="return false;"   ondrop="return false;" v-model='record.location' class='form-control' name='nickname' type='text'>
            </div>
          </div>
          <div class='col-lg-3 col-md-3 col-sm-6' style='padding: 10px 0px 0px 10px;'>
              <label>مجموعة تغيير الشمع:</label>
              <select class="form-control" style="padding: 0px" v-model="record.maintenance_group_id">
                <option v-for="type in maintenanceGroups" v-bind:key="type.id" v-bind:value="type.id">
                  {{ type.group_name }}
                </option>
              </select>
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
            <label>ملاحظات:</label>
            <textarea class="form-control" rows="6" v-model="record.notes"></textarea>
          </div>
          <div class='col-md-6 col-md-offset-3' style='padding: 10px 0px 10px 10px;   text-align:center;'>
            <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
            <button @click='saveData'  type='button' class='btn btn-block btn-md btn-success'><i class="fa fa-save"></i> <b>حفظ</b></button>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <code>{{ recordMetaInfo }}</code>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style media="screen">
.form-alerts {
  position: sticky;
  top: 0;
  z-index: 5;
  background: #fff;
}
</style>
<script>
import API from '@/store/api'
import Swal from 'sweetalert2'
export default {
  name: 'CustomerData',
  data () {
    return {
      validationErrors: '',
      record: {},
      isLoadingSave: false,
      types: [{id: 1, name: 'نشط'}, {id: 0, name: 'غير نشط'}],
      evalus: [{id: 0, name: 'غير مقيم'}, {id: 1, name: 'سيئ جدا'}, {id: 2, name: 'سيئ'}, {id: 3, name: 'جيد'}, {id: 4, name: 'جيد جدا'}],
      branches: {},
      governorates: {},
      cities: {},
      lines: {},
      regions: {},
      maintenanceGroups: {},
      contTitle: ''
    }
  },
  computed: {
    recordMetaInfo () {
      if (!this.record) return ''
      const created = this.formatDateTime(this.record.created_at)
      const updated = this.formatDateTime(this.record.updated_at)
      const user = this.record.user_name || ''
      return `تاريخ الانشاء ${created} | آخر تعديل ${updated} | بواسطة: ${user}`
    }
  },
  // =========================================================================
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.governorates = JSON.parse(localStorage.getItem('Gov'))
  },
  methods: {
    formatDateTime (dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      let hours = d.getHours()
      const minutes = d.getMinutes().toString().padStart(2, '0')
      const day = d.getDate().toString().padStart(2, '0')
      const month = (d.getMonth() + 1).toString().padStart(2, '0')
      const year = d.getFullYear()

      const isPM = hours >= 12
      const suffix = isPM ? 'م' : 'ص'

      hours = hours % 12
      hours = hours === 0 ? 12 : hours
      hours = hours.toString().padStart(2, '0')

      return `${year}/${month}/${day} ${hours}:${minutes}${suffix}`
    },
    // =========================================================================
    pageLoad (rec) {
      this.record = rec
      this.FillItineraries()
      if (rec.id !== 0) {
        this.FillCitys()
        this.FillRegions()
      }
      this.FillMaintenanceGroups()
    },
    // ===============================================================
    isValidMobile (mobile) {
      if (!mobile) return false

      const phone = mobile.toString().replace(/[^0-9]/g, '')
      return phone.length === 11
    },
    // ===============================================================
    openWhatsapp (mobile) {
      if (!this.isValidMobile(mobile)) {
        Swal.fire({
          position: 'fixed',
          icon: 'error',
          title: 'عفوا رقم المحمول غير صحيح',
          showConfirmButton: false,
          timer: 3000
        })
        return
      }

      const phone = mobile.toString().replace(/[^0-9]/g, '')
      const finalPhone = '20' + phone

      const url = `https://wa.me/${finalPhone}`
      window.open(url, '_blank')
    },
    // =========================================================================
    openLocation (location) {
      window.open(
        'https://www.google.com/maps?q=' + location,
        '_blank'
      )
    },
    // =========================================================================
    FillCitys (reset = false) {
      if (reset) {
        this.record.city = null
      }
      this.cities = []
      let i = this.governorates.map(record => record.id).indexOf(parseInt(this.record.governorate))
      if (i > -1) {
        this.cities = JSON.parse(JSON.stringify(this.governorates[i].cities))
      }
    },
    // =========================================================================
    FillMaintenanceGroups (reset = false) {
      if (reset) {
        this.record.maintenance_group_id = null
      }
      this.maintenanceGroups = []
      let i = this.branches.map(record => record.id).indexOf(parseInt(this.record.branche_id))
      if (i > -1) {
        this.maintenanceGroups = JSON.parse(JSON.stringify(this.branches[i].maintenance_groups))
      }
    },
    // =========================================================================
    FillItineraries (reset = false) {
      if (reset) {
        this.record.line_id = null
        this.record.region_id = null
      }
      let i = this.branches.map(record => record.id).indexOf(parseInt(this.record.branche_id))
      this.regions = []
      this.lines = JSON.parse(JSON.stringify(this.branches[i].itineraries))
    },
    // =========================================================================
    FillRegions (reset = false) {
      if (reset) {
        this.record.region_id = null
      }
      this.regions = []
      let i = this.lines.map(record => record.id).indexOf(parseInt(this.record.line_id))
      if (i > -1) {
        this.regions = JSON.parse(JSON.stringify(this.lines[i].regions))
      }
    },
    // =========================================================================
    validateForm () {
      const rules = {
        branche_id: [
          v => !!v || 'حقل الفرع مطلوب'
        ],
        line_id: [
          v => !!v || 'حقل الخط مطلوب'
        ],
        region_id: [
          v => !!v || 'حقل المنطقة مطلوب'
        ],
        name: [
          v => (!!v && v.trim().length >= 5) || 'حقل الاسم مطلوب',
          v => (!v || v.trim().length <= 100) || 'حقل الاسم مطلوب'
        ],
        rec_id: [
          v => !!v || 'حقل رقم السجل مطلوب',
          v => !v || Number.isInteger(+v) || 'حقل رقم السجل يجب ان يكون رقم'
        ],
        governorate: [
          v => !!v || 'حقل المحافظة مطلوب'
        ],
        city: [
          v => !!v || 'حقل [ المركز / المدينة / الحي ] مطلوب'
        ],
        village: [
          v => !v || v.length <= 50 || 'حقل القرية يجب ان لا يزيد عن 50 حرف'
        ],
        address: [
          v => !v || v.length <= 100 || 'حقل العنوان يجب ان لا يزيد عن 100 حرف'
        ],
        mobile: [
          // 1️⃣ فاضي → عدي من غير أي رسالة
          v => !v || true,

          // 2️⃣ لو فيه أي حرف (حتى لو مع أرقام)
          v => !v || /^\d+$/.test(v) || 'حقل المحمول يجب ان يكون رقما',

          // 3️⃣ لو كله أرقام لكن الطول غلط
          v => !v || !/^\d+$/.test(v) || v.length === 11 || 'حقل المحمول يجب ان يكون 11 رقم',

          // 4️⃣ لو كله تمام بس مش بادئ بـ 01
          v => !v || !/^\d{11}$/.test(v) || v.startsWith('01') || 'رقم المحمول خطأ'
        ],
        mobile2: [
          v => !v || v.length <= 15 || 'حقل المحمول الثانى / الأرضى يجب ان لا يزيد عن 15 رقم',
          v => !v || Number.isInteger(+v) || 'حقل المحمول الثانى / الأرضى يجب ان يكون رقم'
        ],
        idcard: [
          v => !v || v.length === 14 || 'حقل رقم البطاقة يجب ان يكون 14 رقم',
          v => !v || v.length !== 14 || /^\d+$/.test(v) || 'حقل رقم البطاقة يجب ان يكون رقما'
        ],
        maintenance_group_id: [
          v => !!v || 'مجموعة تغيير الشمع مطلوبة'
        ]
      }
      this.validationErrors = []

      Object.keys(rules).forEach(field => {
        rules[field].forEach(rule => {
          const result = rule(this.record[field])
          if (result !== true) {
            this.validationErrors.push(result)
          }
        })
      })

      return this.validationErrors.length === 0
    },
    // =========================================================================
    async saveData () {
      if (!this.validateForm()) {
        return
      }
      this.isLoadingSave = true
      try {
        const data = await API.saveCustomer(this.record)
        this.record = data
        this.$emit('return-data', data)
        Swal.fire({
          position: 'fixed',
          icon: 'success',
          title: 'تم الحفظ بنجاح',
          showConfirmButton: false,
          timer: 1000
        })
      } catch (err) {
        this.validationErrors = err.errors
      }
      this.isLoadingSave = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Customers/CustomerData.vue